import { render, staticRenderFns } from "./FbUpdateSitePrincipal.vue?vue&type=template&id=ff1d8eb4"
import script from "./FbUpdateSitePrincipal.vue?vue&type=script&lang=ts"
export * from "./FbUpdateSitePrincipal.vue?vue&type=script&lang=ts"
import style0 from "./FbUpdateSitePrincipal.vue?vue&type=style&index=0&id=ff1d8eb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports